import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import contentfulApi from "../../utils/contentful";
import { callToLearnMoreButtonClicked } from "utils/segment";

import PageHeader from "../../components/PageHeader";
import Row from "../../components/Row";
import Col from "../../components/Col";
import Container from "../../components/Container";
import Button from "../../components/Button";

import Article from "../Press/Article";

import BlogHeader from "../../assets/blogHeader.png";

const Blog = (props) => {
  const [data, setData] = useState({});
  const [dataLoaded, setDataLoaded] = useState(false);

  useEffect(() => {
    contentfulApi
      .getEntries({
        content_type: "blogPost",
      })
      .then((response) => {
        if (response.items.length === 0) {
          props.history.push("/");
        } else {
          setData(Object.assign(response.items));
          setDataLoaded(true);
        }
      });
  }, [props]);

  if (!dataLoaded) {
    return null;
  }

  return (
    <div className="blog">
      <PageHeader>
        <Row>
          <Col md={7}>
            <h1>Papa Blog</h1>
            <hr />
            <p>
              Read the latest blog posts from our amazing writers and guest
              bloggers.
            </p>

            <div className="hidden-desktop text-center text-uppercase font-600 mb-10">
              Call to learn more
            </div>
            <Button
              href="tel:+1-800-348-7951"
              onClick={callToLearnMoreButtonClicked}
            >
              <span className="hidden-mobile">Call to learn more</span>{" "}
              1-800-348-7951
            </Button>
          </Col>
        </Row>

        <img
          src={BlogHeader}
          alt="Papa"
          className="page-header__image hidden-mobile blog_image"
        />
      </PageHeader>

      <div className="press-articles">
        <Container>
          <div className="featured-article">
            <Row className="flex align-center">
              <Col md={6}>
                <Link to={`/blog/${data[0].fields.slug}`}>
                  <img
                    src={
                      data[0].fields.image &&
                      data[0].fields.image.fields.file.url
                    }
                    alt="Featured article"
                    className="img-responsive"
                  />
                </Link>
              </Col>

              <Col md={6}>
                <h3 className="mb-30">{data[0].fields.title}</h3>
                <p>{data[0].fields.excerpt}</p>

                <Link to={`/blog/${data[0].fields.slug}`}>Read More</Link>
              </Col>
            </Row>
          </div>

          <Row>
            {data.slice(1).map((post, index) => (
              <Col md={3} key={`key_${index}`}>
                <Link to={`/blog/${post.fields.slug}`}>
                  <Article
                    image={
                      post.fields.image && post.fields.image.fields.file.url
                    }
                  >
                    <h4 className="mb-10">{post.fields.title}</h4>
                    <p>{post.fields.excerpt}</p>
                  </Article>
                </Link>
              </Col>
            ))}
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default Blog;
